$(document).on('page:change', function() { window.teachableIcons.loadSVG() });